import api from '@/api/index';
import { useAudioStore } from '@/stores/audio';
import { useCallStore } from '@/stores/call';
import { useSocketStore } from '@/stores/socket';
import { useUserStore } from '@/stores/user';
import { IResponseUserInfo } from '@/types/response';
import { ConnectionInfo } from '@/types/socket';
import { getBrowserAndDeviceInfo } from '@/utils/device';

export function useSocketSubtitle(chatId: Ref<string | null>) {
  const route = useRoute();
  const router = useRouter();

  const audioStore = useAudioStore();
  const callStore = useCallStore();
  const socketStore = useSocketStore();
  const userStore = useUserStore();

  const userInfo = ref<IResponseUserInfo | null>(null);

  const hasModeSubtitle = (subtitleMode) => {
    return String(subtitleMode ?? '').toLowerCase() === 'true';
  };

  const connectToWebsocket = async () => {
    const { code } = route.query;
    const resultQR = await api.get(`/api/qr/${code}`);

    if (code === resultQR.data.hostCode) {
      await router.push({ name: 'error-not-found' });
    }

    if (!hasModeSubtitle(resultQR.data.options?.subtitleMode)) {
      await router.push({ name: 'error-not-found' });
    }

    callStore.setQrCodeInfo(resultQR.data);
    const guestCode = resultQR.data.guestCode;

    if (userInfo.value === null || socketStore.connectionResponse === 4010) {
      const result = await api.get('/api/user/info/web', {
        headers: {
          'NO-AUTHORIZATION-TOKEN': '1',
        },
      });

      userInfo.value = result.data;
      userStore.userInfo = result.data;
      sessionStorage.setItem('userId', result.data.userId); //임시 추가, 언어변경시 이걸 사용하므로 변수로 빼면 좋을듯
    }

    const resultNext = await api.get(`/api/chat/business/call/${guestCode}/next`, {
      responseType: 'text',
    });
    chatId.value = resultNext.data;

    const agent = JSON.stringify(await getBrowserAndDeviceInfo()); // 사용자 브라우저 및 장치 정보

    const connectionInfo: ConnectionInfo = {
      userId: userInfo.value!.userId,
      token: `SC-USER-ID ${userInfo.value!.webTokenResponse.value}`,
      isRegister: '0',
      isTssOn: '0',
      voiceId: '0',
      chatId: resultNext.data,
      languageCode: audioStore.languageSelected?.code ?? 'ko',
      nickname: userInfo.value!.nickname,
      isPartnerPerson: '0',
      longVoice: '0',
      evictMySelf: '1',
      code: resultQR.data.guestCode,
      callType: resultQR.data.callType,
      connectionType: 'SUBTITLE',
      agent,
    };

    socketStore.setConnectInfo(connectionInfo);
    await socketStore.setupWebSocket();
  };
  return {
    connectToWebsocket,
  };
}
